import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip.js";
import { ThemeProvider, THEME_STORAGE_KEY, applyThemeToDocument, type Theme } from "@/lib/theme.js";
import { getQueryClient } from "@/lib/queryClient.js";
import { router } from "@/routes/router.js";
import "./index.css";

try {
  const raw = localStorage.getItem(THEME_STORAGE_KEY);
  const theme: Theme = raw === "light" || raw === "dark" || raw === "system" ? raw : "system";
  applyThemeToDocument(theme);
} catch {
  applyThemeToDocument("system");
}

const queryClient = getQueryClient();

const el = document.getElementById("root");
if (!el) throw new Error("missing #root");
createRoot(el).render(
  <StrictMode>
    <ThemeProvider>
      <TooltipProvider delayDuration={250}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" />
        </QueryClientProvider>
      </TooltipProvider>
    </ThemeProvider>
  </StrictMode>
);
